import React, { createContext, useState, useEffect, useContext } from 'react';
import { defaultRequestQueueManager as requestQueueManager } from 'components/layout_and_quote_builder/utils/RequestQueueManager.js';

const ProgressContext = createContext();

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgress must be used within a ProgressProvider');
  }
  return context;
};

export const ProgressProvider = ({ children }) => {
  const [progress, setProgress] = useState({
    completed: 0,
    total: 0,
    percentage: 0
  });

  useEffect(() => {
    // Reset progress when provider mounts
    requestQueueManager.reset();

    // Subscribe to progress updates
    const unsubscribe = requestQueueManager.onProgress((progressInfo) => {
      setProgress(progressInfo);
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  const resetProgress = () => {
    requestQueueManager.reset();
  };

  return (
    <ProgressContext.Provider value={{ progress, resetProgress }}>
      {children}
    </ProgressContext.Provider>
  );
};

export default ProgressContext;
